import M from 'messages';

export const videoGuides = [
  {
    title: M.get('welcome.videoGuides.videos.gettingStarted.title'),
    description: M.get('welcome.videoGuides.videos.gettingStarted.description'),
    duration: M.get('welcome.videoGuides.videos.gettingStarted.duration'),
    url: 'https://youtu.be/AlbxAJkf0tU',
    chipText: M.get('welcome.videoGuides.videos.gettingStarted.chipText'),
  },
  {
    title: M.get('welcome.videoGuides.videos.eventsFestivals.title'),
    description: M.get('welcome.videoGuides.videos.eventsFestivals.description'),
    duration: M.get('welcome.videoGuides.videos.eventsFestivals.duration'),
    url: 'https://www.youtube.com/watch?v=_KW0dxh691k',
  },
  {
    title: M.get('welcome.videoGuides.videos.wineriesDistilleries.title'),
    description: M.get('welcome.videoGuides.videos.wineriesDistilleries.description'),
    duration: M.get('welcome.videoGuides.videos.wineriesDistilleries.duration'),
    url: 'https://www.youtube.com/watch?v=bDsMDToUEfw',
  },
  {
    title: M.get('welcome.videoGuides.videos.wineBarsRestaurants.title'),
    description: M.get('welcome.videoGuides.videos.wineBarsRestaurants.description'),
    duration: M.get('welcome.videoGuides.videos.wineBarsRestaurants.duration'),
    url: 'https://www.youtube.com/watch?v=ma9YUx2wN08',
  },
  {
    title: M.get('welcome.videoGuides.videos.importersDistributors.title'),
    description: M.get('welcome.videoGuides.videos.importersDistributors.description'),
    duration: M.get('welcome.videoGuides.videos.importersDistributors.duration'),
    url: 'https://www.youtube.com/watch?v=P6G1zHkHyvk',
  },
];
